import { useState, useEffect } from "react";
import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { getUserSession } from '../../../core/util/core/Session';
import { useDispatch } from 'react-redux';
import ApprovePreSale from '../Sales/Modals/ApprovePreSale';
import ReprovePreSale from '../Sales/Modals/ReprovePreSale';

function List() {
    const session = getUserSession();
    const profileFilter = chooseProfileFilter();
    const dispatch = useDispatch();

    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showReproveModal, setShowReproveModal] = useState(false);
    const [selectedApproval, setSelectedApproval] = useState(null);

    const openApproveModal = (approval) => {
        console.log(approval)
        setSelectedApproval(approval);
        setShowApproveModal(true);
    };

    const openReproveModal = (approval) => {
        setSelectedApproval(approval);
        setShowReproveModal(true);
    };

    const handleCloseModal = () => {
        setSelectedApproval(null);
        setShowApproveModal(false);
        setShowReproveModal(false);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    };

    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathView: '/gci/pre-sales/view',
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpoint: `${endpointBackend}gci/approval-sales-requests/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Solicitação de Aprovação de Venda',
        labelTitleButtonAdd: 'Incluir nova solicitação de aprovação de venda',
        fieldsShowOnDelete: ['company'],
        formFilters: !profileFilter.gci_company_id ? filters : null,
        filter: {
            ...profileFilter,
            status: 'pending',
            core_application_profile_id: session.user.application_profile_id
        },
        canEdit: false,
        canDelete: false,
        columns: [
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'project',
                label: 'Projeto'
            },
            {
                name: 'unit',
                label: 'Unidade',
                width: '10%'
            },
            {
                name: 'real_state',
                label: 'Imobiliária'
            },
            {
                name: 'business_type',
                label: 'Tipo de Negócio'
            },
            {
                name: 'value',
                label: 'Valor'
            },
            {
                name: 'approval',
                label: 'Aprovar/Reprovar',
                width: '12%',
                cell: row => (
                    <div>
                        <a
                            className="btn btn-success btn-sm btn-action"
                            style={{ marginRight: '5px', color: '#fff' }}
                            onClick={() => openApproveModal(row)}
                            title="Aprovar"
                        >
                            <i className="fas fa-check"></i>
                        </a>
                        <a
                            className="btn btn-danger btn-sm btn-action"
                            style={{ color: '#fff' }}
                            onClick={() => openReproveModal(row)}
                            title="Reprovar"
                        >
                            <i className="fas fa-close"></i>
                        </a>
                    </div>
                )
            }
        ],
        columnsButtons: []
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={false}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />

            {/* --------------------------
                MODAL DE CANCELAMENTO
            --------------------------- */}
            {showApproveModal && (
                <ApprovePreSale
                    show={showApproveModal}
                    onClose={handleCloseModal}
                    saleId={selectedApproval?.id}
                    approvalId={selectedApproval?.gci_approval_sales_request_id}
                />
            )}

            {showReproveModal && (
                <ReprovePreSale
                    show={showReproveModal}
                    onClose={handleCloseModal}
                    saleId={selectedApproval?.id}
                    approvalId={selectedApproval?.gci_approval_sales_request_id}
                />
            )}
        </div>
    );
}

export default List;
